
export interface JitoStakePoolStats {
  apy: {
    data: number;
    date: string;
  }[];
  tvl: {
    data: number;
    date: string;
  }[];
}

export const fetchJitoAPY = async (): Promise<number | null> => {
  try {
    const response = await fetch('https://kobe.mainnet.jito.network/api/v1/stake_pool_stats');
    if (!response.ok) {
      throw new Error(`Failed to fetch Jito stats: ${response.statusText}`);
    }
    const data: JitoStakePoolStats = await response.json();
    
    if (data.apy && data.apy.length > 0) {
      // Get the latest APY (last element in the array)
      const latestEntry = data.apy[data.apy.length - 1];
      if (latestEntry && typeof latestEntry.data === 'number') {
        return latestEntry.data;
      }
    }
    
    return null;
  } catch (error) {
    console.error('Error fetching Jito APY:', error);
    return null;
  }
};
